import {useEffect, useMemo} from 'react';

import {ErrorBadgeError} from 'procedures/design/error-panel/ErrorBadge';

import {PlanDesignActions, useProcedureRunPlanContext} from '../overview/StudyOverviewContexts';
import {StudyDesignTabEditState} from './StudyDesignTabSavingButtons';

export interface UsePlanDesignActionsParams {
  editState: StudyDesignTabEditState;
  hasUnsavedChanges: boolean;
  onSave: () => Promise<void>;
  isSaveDisabled: boolean;
  saveDisabledTooltip?: string;
  errors: Array<ErrorBadgeError>;
}

export default function usePlanDesignActions(params: UsePlanDesignActionsParams): PlanDesignActions {
  const {editState, hasUnsavedChanges, onSave, isSaveDisabled, saveDisabledTooltip, errors} = params;
  const planDesignActions = useMemo<PlanDesignActions>(
    () => ({
      editState,
      hasUnsavedChanges,
      onSave,
      isSaveDisabled,
      saveDisabledTooltip,
      errors,
    }),
    [editState, errors, hasUnsavedChanges, isSaveDisabled, onSave, saveDisabledTooltip]
  );

  const {setPlanDesignActions} = useProcedureRunPlanContext();
  useEffect(() => {
    setPlanDesignActions(planDesignActions);
    return () => {
      setPlanDesignActions(null);
    };
  }, [planDesignActions, setPlanDesignActions]);

  return planDesignActions;
}
